import type { CSSProperties } from "react";
import { formatDateTime, formatRelativeTime } from "@/lib/format-datetime";
import { useTick } from "@/lib/useTick";

interface RelativeTimestampProps {
	iso: string;
	style?: CSSProperties;
	"data-testid"?: string;
}

/**
 * 相対時刻（例: 「5分前」）を表示し、hover で絶対時刻を出す。
 * `useNowTick` の購読をこのコンポーネントに閉じ込めることで、
 * 親メッセージや ToolGroupCard 全体の再描画を避ける。
 */
export function RelativeTimestamp({ iso, style, "data-testid": testId }: RelativeTimestampProps) {
	useTick(60_000);
	const ageMs = Date.now() - new Date(iso).getTime();
	const label = ageMs < 60_000 ? "たった今" : formatRelativeTime(iso);
	return (
		<span data-testid={testId} title={formatDateTime(iso)} style={style}>
			{label}
		</span>
	);
}
